import { AfterViewInit, Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie';



@Component({
  selector: 'app-checkbox-fragment',
  templateUrl: './checkbox-fragment.component.html',
  styleUrls: ['./checkbox-fragment.component.scss']
})
export class CheckboxFragmentComponent implements OnInit, AfterViewInit {

  @Input() formItem: any;
  @Input() invalidForm: any;
  @Input() formId:any;

  @Output() callUpdate = new EventEmitter();

  constructor(  private cookieService: CookieService) { }

  isRequired: any;
  checkboxOptions: any;
  formTitle: string;
  languageId: number = 1;

  get selectedOptions() {
    return !!this.checkboxOptions.filter(option => {
      return option.boolValue === true;
    })[0];
  }

  ngOnInit() {
    // Delete parent BoolValue
    delete this.formItem.value;
    this.isRequired = this.formItem.item.isRequired;
    this.languageId = Number(this.cookieService.get('formLanguage'));
  }

  changeValue(option) {
    this.formItem.boolValue = !this.formItem.boolValue;
    if (this.formItem.item.isConditional) {
      this.callUpdate.emit();
    }
  }

  getLabel() {
    try {
        let optionFound = this.formItem.item.itemLabels.filter(x => x.language !== null && x.language !== undefined && x.language.idLanguage === this.languageId)[0];
        if (optionFound?.labelField && optionFound.labelField !== '')
          return optionFound.labelField;
        else {
          return this.formItem.item.itemLabels[0].labelField;
        }
    }
    catch (Exception) {
      console.log("ERROR LABELS");
      return '';
    }
  }

  ngAfterViewInit() {
      setTimeout(_ => {

      });
    }
}
